import { Skeleton } from '@vizit/atoms';

/**
 * Loading content shared by every product page performance metric cell, so the row
 * shimmers as one: a caption and indicator in the header, then a number block over a
 * notes line — the same footprint as the loaded cell. Rendered inside the cell's own
 * container so the cell keeps one root element from loading to loaded.
 */
function MetricCardSkeleton() {
  return (
    <>
      <div className="flex w-full items-start justify-between">
        <Skeleton variant="square" className="h-5 w-24" />
        <Skeleton variant="square" className="h-7 w-28" />
      </div>
      <div className="flex flex-col gap-2">
        <Skeleton variant="square" className="h-[42px] w-20" />
        <Skeleton variant="square" className="h-3 w-28" />
      </div>
    </>
  );
}

export { MetricCardSkeleton };
